'use client';

import { ComparerContent } from '../comparer/ComparerContent';

export function ComparerTabWrapper() {
  return <ComparerContent />;
}
